import React, { useEffect, useRef, useState } from "react";
import { LatLngExpression } from "leaflet";
import { Alert, Autocomplete, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, IconButton, ListItemText, MenuItem, Select, SelectChangeEvent, Snackbar, SnackbarCloseReason, TextField } from "@mui/material";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import { useLocation, useNavigate } from "react-router-dom";
import { PropertyObj } from "../../Models/PropertyObj";
import { GenerateDescServ, GenerateDescTitleServ, GenerateTitleServ, GetTemplateServ, SaveTemplateServ } from "../../Services/Generate";
import PlacesAutocomplete from "../listing-ceation/TitleAndDesc/places-autocomplete";
import LoacationMaps from "../listing-ceation/TitleAndDesc/location-map";
import PropertyDetails from "../listing-ceation/TitleAndDesc/property-details";
import Country from "../listing-ceation/TitleAndDesc/country";
import PrivateAmenities from "../listing-ceation/TitleAndDesc/private-amenities";
import SharedAmenities from "../listing-ceation/TitleAndDesc/shared-amenities";
import SpecialAboutProperty from "../listing-ceation/TitleAndDesc/special_about_property";
import DescriptionDetails from "../listing-ceation/TitleAndDesc/description-details";
import { SavePropertyDesc } from "../../Services/DescriptionTitle";
import UploadTemplate, { Template } from "./upload-template";
import CloseIcon from '@mui/icons-material/Close';
import InputLabel from '@mui/material/InputLabel';
import GenerateDescription from "./generate-description";
import GenerateTitle from "./generate-title";
import { useTranslation } from "react-i18next";
import { UploadTemplateServ } from "../../Services/Properties";


const theme = createTheme({
    components: {
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    backgroundColor: '#ffffff',
                    padding: "10px",
                    color: 'rgba(0, 0, 0, 0.6)',
                    boxShadow: '0px 4px 48px rgba(0, 0, 0, 0.1)',
                    fontFamily: 'Plus Jakarta Sans',
                    fontStyle: "normal",
                    fontWeight: "500",
                    fontSize: "12px",
                    lineHeight: "13px",
                    width: "100%"
                },
                arrow: {
                    color: '#ffffff',
                },
            },
        },
    },
});

const GenerateNewDescription: React.FunctionComponent<{}> = (props) => {
    const seo = {
        "name": "SEO optimazed",
        "length": "Short and Concise",
        "tone": "Formal and Professional",
        "style": "Rustic and Charming",
        "minCharactersDesc": 1000,
        "maxCharactersDesc": 1300,
        "minCharactersTitle": 50,
        "maxCharactersTitle": 76,
        "template": "seo_optimized",
        "imagesAnalysis": true,
        "agencyIntroduction": true,
    }
    const defaultDesc = {
        name: "Default",
        length: "Detailed and Elaborate",
        tone: "Cozy and Inviting",
        style: "Modern and Sleek",
        minCharactersDesc: 1200,
        maxCharactersDesc: 1500,
        minCharactersTitle: 50,
        maxCharactersTitle: 100,
        imagesAnalysis: true,
        template: "default",
        agencyIntroduction: true,
    }
    const [langDesc, setlangDesc] = useState<any>(() => {
        const storedData = sessionStorage.getItem("property_details");
        if (storedData) {
            try {
                const parsed = JSON.parse(storedData);
                if (Array.isArray(parsed.lang) && parsed.lang.length > 0) {
                    return parsed.lang[0];
                }
            } catch (e) {
                console.error("Failed to parse property_details:", e);
            }
        }
        return "";
    });
    function getRandomSevenDigitNumber(): number {
        return Math.floor(1000000 + Math.random() * 9000000);
    };
    const [langTitle, setlangTitle] = useState<any>(() => {
        const storedData = sessionStorage.getItem("property_details");
        if (storedData) {
            try {
                const parsed = JSON.parse(storedData);
                if (Array.isArray(parsed.lang) && parsed.lang.length > 0) {
                    return parsed.lang[0];
                }
            } catch (e) {
                console.error("Failed to parse property_details:", e);
            }
        }
        return "";
    });
    const [property, setProperty] = useState<PropertyObj>({
        size: {
            unitBuiltUp: "Sq M",
            unitPlot: "Sq M"
        },
        idProperty: getRandomSevenDigitNumber(),
        descriptionTitle: defaultDesc,
        view: "",
    });
    const [position, setPosition] = useState<LatLngExpression>([25.2048493, 55.2707828]);
    const [zoomValue, setZoomValue] = useState(14);
    const [isGenerate, setIsGenerate] = useState(false);
    const [templateSelected, setTemplateSelected] = useState<any>(defaultDesc);
    const [listTemplate, setListTemplate] = useState<any>([]);
    const [isChange, setIsChange] = useState<boolean>(false);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [colorSnackbar, setColorSnackbar] = useState<any>("");
    const [message, setMessage] = useState<string>();
    const navigate = useNavigate()
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [templateName, setTemplateName] = useState<any>();
    const [errors, setErrors] = useState<{ [key: string]: boolean }>({});
    const [SizeValue, setSizeValue] = useState<any>();
    const { t } = useTranslation();

    // Define language options based on country
    const getLanguageOptions = (country: any) => {
        const languageConfig: any = {
            "UAE": [
                { value: "arabic", label: "Arabic" },
                { value: "english", label: "English" },
                { value: "french", label: "French" },
                { value: "spanish", label: "Spanish" }
            ],
            "ME": [
                { value: "english", label: "English" },
                { value: "german", label: "German" },
                { value: "serbian", label: "Serbian" },
                { value: "polish", label: "Polish" },
                { value: "russian", label: "Russian" }
            ],
            "default": [
                { value: "english", label: "English" },
                { value: "french", label: "French" },
                { value: "spanish", label: "Spanish" }
            ]
        };

        // Return the country-specific options or default if not found
        return languageConfig[country] || languageConfig["default"];
    };

    useEffect(() => {
        GetTemplateServ().then((resp) => {
            const updatedList = [defaultDesc, seo, ...resp];
            setListTemplate(updatedList);
        })
    }, [isChange])

    const handleChangeProperty = (data: any) => {
        setProperty((prevOptions: any) => {
            const updatedProperty = {
                ...prevOptions,
                ...data
            };
            return updatedProperty;
        });
    }

    const handleChangeSize = (sizeValue: any) => {
        setSizeValue(sizeValue);
    }

    // Location

    const handleChangeCountry = (event: any) => {
        const country = event.target.value;

        const validLangs = getLanguageOptions(country).map((l: any) => l.value);

        setProperty((prevOptions: any) => {
            const filteredLangs = (prevOptions.lang || []).filter((l: string) => validLangs.includes(l));

            return {
                ...prevOptions,
                address: {
                    ...prevOptions.address,
                    country: country
                },
                price: {
                    currency: country === "UAE" ? "AED" : "GBP"
                },
                lang: filteredLangs
            };
        });
    }

    const handleChangeAdress = (data: any) => {
        setProperty((prevOptions: any) => ({
            ...prevOptions,
            address: {
                ...prevOptions.address,
                city: data.city,
                Community: data.community,
                subCommunity: data.subCommunity,
                latitude: data.lat,
                buildingName: data.building,
                longitude: data.lng,
                country: data.country,
                address: data.address
            },
        }));
        setPosition([data.lat, data.lng])
    }

    // Amenities

    const handleChangeSharedAmenities = (value: any) => {
        setProperty((prevOptions: any) => {
            const sharedAmenities = prevOptions.sharedAmenities || [];
            let updatedAmenities;
            if (sharedAmenities.includes(value)) {
                updatedAmenities = sharedAmenities.filter((selected: any) => selected !== value);
            } else {
                updatedAmenities = [...sharedAmenities, value];
            }

            return {
                ...prevOptions,
                sharedAmenities: updatedAmenities
            };
        });

    }

    const handleChangePrivateAmenities = (value: any) => {
        setProperty((prevOptions: any) => {
            const privateAmenities = prevOptions.privateAmenities || [];
            let updatedAmenities;
            if (privateAmenities.includes(value)) {
                updatedAmenities = privateAmenities.filter((selected: any) => selected !== value);
            } else {
                updatedAmenities = [...privateAmenities, value];
            }
            return {
                ...prevOptions,
                privateAmenities: updatedAmenities
            };
        });
    }

    // Form Description

    const handleChangeCheck = (event: any) => {
        const { name, checked } = event.target;
        setProperty((prevOptions: any) => ({
            ...prevOptions,
            descriptionTitle: {
                ...prevOptions.descriptionTitle,
                [name]: checked,
            },
        }));
    }

    const handleChangeDescTitle = (event: any) => {
        const { name, value } = event.target;
        setProperty((prevOptions: any) => ({
            ...prevOptions,
            descriptionTitle: {
                ...prevOptions.descriptionTitle,
                [name]: value,
            },
        }));
    }

    const handleSelectLanguge = (event: any) => {
        const { value } = event.target;

        const selectedLangs = typeof value === 'string'
            ? value.split(',')
            : (value as string[]);

        setProperty((prevOptions) => ({
            ...prevOptions,
            lang: selectedLangs,
        }));

        const firstLang = selectedLangs.length > 0 ? selectedLangs[0] : "";
        setlangDesc(firstLang);
        setlangTitle(firstLang);
    }

    const UploadTemplateHandler = async (template: Template): Promise<void> => {

        UploadTemplateServ(template).then((resp) => {
            setOpenSnackbar(true)
            setMessage("Template uploaded successfully")
            setColorSnackbar("success")
            setIsChange(!isChange)
            setProperty((prevOptions: any) => ({
                ...prevOptions,
                descriptionTitle: {
                    ...prevOptions.descriptionTitle,
                    template: template,
                },
            }));
            setTemplateSelected(template.name)
        }).catch((error) => {
            setOpenSnackbar(true)
            setMessage("Failed to Upload Template.")
            setColorSnackbar("error")

        })

    }

    //Edit

    const handleEditDesc = (event: any) => {
        const newValue = event.target.value;
        setProperty((prevProperty: any) => ({
            ...prevProperty,
            description: prevProperty.description.map((item: any) =>
                item.lang === langDesc ? { ...item, desc: newValue } : item
            )
        }));
    }

    const handleEditTitle = (event: any) => {
        const newValue = event.target.value;
        setProperty((prevProperty: any) => ({
            ...prevProperty,
            title: prevProperty.title.map((item: any) =>
                item.lang === langTitle ? { ...item, title: newValue } : item
            )
        }));
    }

    const ChangeLangDesc = (lang: any) => {
        setlangDesc(lang)
    }

    const ChangeLangTitle = (lang: any) => {
        setlangTitle(lang)
    }

    // Generate

    const isFormValid = () => {
        if (!property) return false;

        const requiredFields = [
            property.address,
            property.offeringType,
            property.propertyType,
            property.furnishingType,
            property.bedroom,
            property.bathroom,
            (property?.description?.length ?? 0) > 0,
            property.idProperty,
            property.price?.amount,
            property.price?.currency,
            property.size?.builtUpSize,
            property.size?.plotSize,
            property.size?.unitBuiltUp,
            property.size?.unitPlot,
            property.completionStatus,
            ...(property.address?.country === "UAE" ? [property.Permit] : [])
        ];

        const descriptionValid = property.descriptionTitle
            && property.descriptionTitle.maxCharactersDesc
            && property.descriptionTitle.maxCharactersTitle
            && property.descriptionTitle.minCharactersDesc
            && property.descriptionTitle.minCharactersTitle
            && property.descriptionTitle.style
            && property.descriptionTitle.tone;

        const amenitiesValid =
            (property.privateAmenities?.length ?? 0) > 0

        const langValid = (property.lang?.length ?? 0) > 0;

        const isValid = requiredFields.every(Boolean) && descriptionValid && amenitiesValid && langValid;

        return isValid;
    }

      const validateForm = () => {
        const newErrors: { [key: string]: boolean } = {};

        if (!property.address?.country) newErrors.country = true;
        if (!property.address?.address) newErrors.address = true;
        if (!property.offeringType) newErrors.offeringType = true;
        if (!property.category) newErrors.category = true;
        if (!property.propertyType) newErrors.propertyType = true;

        if (!property.descriptionTitle?.length) newErrors.desclength = true;
        if (!property.descriptionTitle?.style) newErrors.style = true;
        if (!property.descriptionTitle?.tone) newErrors.tone = true;

        if (!property.privateAmenities || property.privateAmenities.length === 0)
            newErrors.privateAmenities = true;

        if (!property.lang || property.lang.length === 0) newErrors.lang = true;
        if (!property.furnishingType) newErrors.furnishingType = true;

        if (property.category === "residential") {
            if (property.bedroom === undefined || property.bedroom === null)
                newErrors.bedroom = true;

            if (property.bathroom === undefined || property.bathroom === null)
                newErrors.bathroom = true;
        }

        if (!property.price?.amount) newErrors.amount = true;
        if (!property.price?.currency) newErrors.currency = true;

        if (!SizeValue.plotSize) newErrors.plotSize = true;
        if (!SizeValue.builtUpSize) newErrors.builtUpSize = true;
        if (!property.idProperty) newErrors.idProperty = true;

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const handleGenerateDesc = () => {
        return new Promise((resolve, reject) => {
            GenerateDescServ("", property, langDesc).then((resp) => {
                const result = resp.data.result?.trim();

                if (result) {
                    setProperty((prevOptions: any) => {
                        const updatedDesc = prevOptions.description.map((item: any) =>
                            item.lang === langDesc ? { ...item, desc: result } : item
                        );
                        const updatedProperty = {
                            ...prevOptions,
                            description: updatedDesc
                        };
                        return updatedProperty;
                    });
                    setOpenSnackbar(true)
                    setMessage("Description Generated Successfully!")
                    setColorSnackbar("success")
                } else {
                    setOpenSnackbar(true)
                    setMessage("Failed to generate description. Please try again.")
                    setColorSnackbar("error")
                }
                resolve(resp);
            })
                .catch((error) => {
                    reject(error);
                    setOpenSnackbar(true)
                    setMessage("Failed to generate description. Please try again.")
                    setColorSnackbar("error")
                });
        })
    }

    const handleGenerateTitle = () => {
        return new Promise((resolve, reject) => {
            GenerateTitleServ("", property, langTitle).then((resp) => {
                const result = resp.data.result?.trim();
                if (result) {
                    setProperty((prevOptions: any) => {
                        const updatedDesc = prevOptions.title.map((item: any) =>
                            item.lang === langTitle ? { ...item, title: result } : item
                        );
                        const updatedProperty = {
                            ...prevOptions,
                            title: updatedDesc
                        };
                        return updatedProperty;
                    });
                    setOpenSnackbar(true)
                    setMessage("Title Generated Successfully!")
                    setColorSnackbar("success")
                } else {
                    setOpenSnackbar(true)
                    setMessage("Failed to generate title. Please try again.")
                    setColorSnackbar("error")
                }
                resolve(resp);
            }).catch((error) => {
                reject(error);
                setOpenSnackbar(true)
                setMessage("Failed to generate title. Please try again.")
                setColorSnackbar("error")
            })
        })
    }

    const Generate = () => {
        setIsGenerate(true)
        const isValid = validateForm();

        setProperty((prevOptions: any) => {
            const updatedProperty = {
                ...prevOptions,
                description: {},
                title: {},
                size: SizeValue
            };
            return updatedProperty
        });

        if (isValid) {
            GenerateDescTitleServ("", {
                ...property,
                description: {},
                title: {},
                size: SizeValue
            }).then((resp) => {
                setIsGenerate(false)
                if (resp && Array.isArray(resp.desc) && Array.isArray(resp.title) && resp.desc.length > 0 && resp.title.length > 0) {
                    setProperty(prevOptions => ({
                        ...prevOptions,
                        description: resp.desc,
                        title: resp.title,
                    }))
                    setOpenSnackbar(true)
                    setMessage("Description and Title Generated Successfully!")
                    setColorSnackbar("success")
                } else {
                    setOpenSnackbar(true)
                    setMessage("Failed to generate description and title. Please try again.")
                    setColorSnackbar("error")
                }
            }).catch((error) => {
                setIsGenerate(false)
                setOpenSnackbar(true)
                setMessage("Failed to generate description and title. Please try again.")
                setColorSnackbar("error")
            })
        } else {
            setIsGenerate(false)
            setOpenSnackbar(true)
            setMessage("Please review the form. Some required fields are missing or incorrectly filled.")
            setColorSnackbar("error")
        }
    }

    //Template

    const SaveTemplate = () => {
        setIsOpen(false)
        const obj = {
            "length": property.descriptionTitle?.length,
            "tone": property.descriptionTitle?.tone,
            "style": property.descriptionTitle?.style,
            "minCharactersDesc": property.descriptionTitle?.minCharactersDesc,
            "maxCharactersDesc": property.descriptionTitle?.maxCharactersDesc,
            "minCharactersTitle": property.descriptionTitle?.minCharactersTitle,
            "maxCharactersTitle": property.descriptionTitle?.maxCharactersTitle,
            "imagesAnalysis": property.descriptionTitle?.imagesAnalysis,
            "agencyIntroduction": property.descriptionTitle?.agencyIntroduction,
            "name": templateName
        }
        SaveTemplateServ(obj).then((resp) => {
            setIsChange(!isChange)
            setOpenSnackbar(true)
            setMessage("Template saved successfully!")
            setColorSnackbar("success")
        }).catch((error) => {
            setOpenSnackbar(true)
            setMessage(error.response.data.error)
            setColorSnackbar("error")
        })
    }

    const handleSelectTemplate = (event: any) => {
        const template = event.target.value;
        setTemplateSelected(template)
        setProperty((prevOptions: any) => ({
            ...prevOptions,
            descriptionTitle: {
                ...prevOptions.descriptionTitle,
                agencyIntroduction: template.agencyIntroduction,
                imagesAnalysis: template.imagesAnalysis,
                length: template.length,
                template: template.name,
                name: template.name,
                maxCharactersDesc: template.maxCharactersDesc,
                maxCharactersTitle: template.maxCharactersTitle,
                minCharactersDesc: template.minCharactersDesc,
                minCharactersTitle: template.minCharactersTitle,
                style: template.style,
                tone: template.tone
            },
        }));
    }

    const handleChangeTemplate = (event: any) => {
        setTemplateName(event.target.value)
    }

    //Copy Text

    const handleCopyText = (textToCopy: any) => {
        if (textToCopy) {
            navigator.clipboard.writeText(textToCopy)
                .then(() => {
                    setOpenSnackbar(true)
                    setMessage("Copied successfully!")
                    setColorSnackbar("success")
                })
                .catch((err) => {
                    setOpenSnackbar(true)
                    setMessage("Failed to copy. Please try again.");
                    setColorSnackbar("error")
                });

        }
    }

    const handleCloseSnackbar = (
        event?: React.SyntheticEvent | Event,
        reason?: SnackbarCloseReason,
    ) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    }

    // Save Description

    const handleSaveDesc = () => {
        SavePropertyDesc(property).then((resp) => {
            setOpenSnackbar(true)
            setMessage("Property description saved successfully!")
            setColorSnackbar("success")
            setTimeout(() => {
                navigate("/AI-description-and-title")
            }, 3000)
        }).catch((error) => {
            setOpenSnackbar(true)
            setMessage("Failed to save property description.");
            setColorSnackbar("error")
        })
    }

    // Change lang

    const getDescriptionByLang = (lang: string) => {
        const descList = property?.description;
        if (!Array.isArray(descList)) return "";
        const found = descList.find((item) => item.lang === lang);
        return found ? found.desc : "";
    }

    const getTitleByLang = (lang: string) => {
        const titleList = property?.title;
        if (!Array.isArray(titleList)) return "";
        const found = titleList.find((item) => item.lang === lang);
        return found ? found.title : "";
    }

    return (
        <div className="container-xxl flex-grow-1 marg-bottom-50">
            <div className="row d-flex justify-content-center align-items-center mt-2 mb-2">
                <div className="tabs width-auto padd-10 ">
                    <button
                        className="tab color-08 title-onest-18 cursor-p tab-active"
                    >
                        {t("generateDescTitle.titleAndDescription")}
                    </button>
                </div>
            </div>
            <div className="row">
                <div className="col-md-1 mt-4">
                    <a href="/AI-description-and-title" className="buuton-next border-trans marg-right-10 size-60 marg-right-16 back-EEF2FF border-9" >
                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6 14L13 7" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M6 14L13 7" stroke="black" strokeOpacity="0.2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M6 14H22.3333" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M6 14H22.3333" stroke="black" strokeOpacity="0.2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M6 14L13 21" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M6 14L13 21" stroke="black" strokeOpacity="0.2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </a>
                </div>

                <div className="col-md-11 justify-content-center mt-4">
                    <div className="header-title">
                        <h1 className="title-24 mb-3 text-center">{t("generateDescTitle.headerTitle")}</h1>
                        <p className="para-16 color-39393B text-center">{t("generateDescTitle.headerSubtitle")}</p>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-md-12">
                    <div className="card border-20 mb-4" >
                        <div className="card-body padd-24">
                            <h3 className="title-20 color-black mb-4">
                                {t("generateDescTitle.location")}
                            </h3>

                            <div className="row card-form mb-4">
                                <div className="col-md-4 mb-3 mb-3">
                                    <label className="form-label-1 mb-2" htmlFor="selectTypeOpt">{t("generateDescTitle.country")}</label>
                                    <FormControl fullWidth>
                                        <Select
                                            className={`input-property mb-3 ${errors.country ? 'input-error' : ''}`}
                                            displayEmpty
                                            inputProps={{ 'aria-label': 'Select' }}
                                            value={property.address?.country || ''}
                                            name="country"
                                            onChange={handleChangeCountry}
                                        >
                                            <MenuItem value="" disabled> {t("propertiesPage.select")} </MenuItem>
                                            <MenuItem value={"UK"}>{t("generateDescTitle.uk")}</MenuItem>
                                            <MenuItem value={"UAE"}>{t("generateDescTitle.uae")}</MenuItem>
                                            <MenuItem value={"ME"}>{t("generateDescTitle.me")}</MenuItem>
                                            <MenuItem value={"FR"}>{t("generateDescTitle.fr")}</MenuItem>
                                        </Select>
                                    </FormControl>

                                    <PlacesAutocomplete property={property} errors={errors} onChangeAdress={handleChangeAdress} />
                                </div>
                                <div className="col-md-8 mb-3">
                                    <LoacationMaps position={position} zoomValue={zoomValue} address={property.address} height={400} />
                                </div>
                            </div>

                            <h3 className="title-20 color-black mb-4">
                                {t("generateDescTitle.propertyDetails")}
                            </h3>

                            <PropertyDetails property={property} errors={errors} onchangeProperty={handleChangeProperty} onchangeSize={handleChangeSize} />

                            <h3 className="title-20 color-black mb-4">
                                {t("generateDescTitle.countrySection")}
                                <ThemeProvider theme={theme}>
                                    <Tooltip title={t("generateDescTitle.countryTooltip")} arrow placement="right">
                                        < button className="border-trans back-trans" > <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clipPath="url(#clip0_528_412)">
                                                <path d="M2.66699 8C2.66699 8.78793 2.82219 9.56815 3.12371 10.2961C3.42524 11.0241 3.8672 11.6855 4.42435 12.2426C4.9815 12.7998 5.64294 13.2417 6.37089 13.5433C7.09885 13.8448 7.87906 14 8.66699 14C9.45492 14 10.2351 13.8448 10.9631 13.5433C11.691 13.2417 12.3525 12.7998 12.9096 12.2426C13.4668 11.6855 13.9087 11.0241 14.2103 10.2961C14.5118 9.56815 14.667 8.78793 14.667 8C14.667 6.4087 14.0349 4.88258 12.9096 3.75736C11.7844 2.63214 10.2583 2 8.66699 2C7.07569 2 5.54957 2.63214 4.42435 3.75736C3.29913 4.88258 2.66699 6.4087 2.66699 8Z" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M8.66699 6H8.67283" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M8 8H8.66667V10.6667H9.33333" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_528_412">
                                                    <rect width="16" height="16" fill="white" transform="translate(0.666992)" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                        </button>
                                    </Tooltip>
                                </ThemeProvider>
                            </h3>

                            <Country property={property} errors={errors} onchangeProperty={handleChangeProperty} country={property.address?.country || "UK"} />

                            <h3 className="title-20 color-black mb-4">
                                {t("generateDescTitle.privateAmenities")}
                            </h3>

                            <PrivateAmenities property={property} errors={errors} onchangePrivateAmenities={handleChangePrivateAmenities} />

                            <h3 className="title-20 color-black mb-4">
                                {t("generateDescTitle.sharedAmenities")} <span className="para-14 color-727272">({t("generateDescTitle.optional")})</span>
                            </h3>

                            <SharedAmenities property={property} onchangeSharedAmenities={handleChangeSharedAmenities} />

                            <SpecialAboutProperty property={property} onchangeProperty={handleChangeProperty} />

                            <div className="row d-flex justify-content-between mb-2">
                                <div className="col-md-6">
                                    <h3 className="title-20 title-18-mb color-black mb-4">
                                        {t("generateDescTitle.descriptionAndTitle")}
                                    </h3>
                                </div>
                                <div className="col-md-6 d-flex-end mb-4">
                                    <UploadTemplate onUploadTemplate={UploadTemplateHandler} />

                                    <FormControl fullWidth className="max-width-25">
                                        <InputLabel id="demo-simple-select-label" sx={{
                                            color: "#6366F1 !important",
                                            fontWeight: "700",
                                            background: "#ffffff"
                                        }}>{t("generateDescTitle.templates")}</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            label="Templates"
                                            className="button-reset"
                                            inputProps={{ 'aria-label': 'Templates' }}
                                            value={templateSelected || ''}
                                            onChange={handleSelectTemplate}
                                            displayEmpty
                                            renderValue={(selected) =>
                                                selected ? selected.name : "Templates"
                                            }
                                            sx={{
                                                "& .MuiSelect-select": {
                                                    border: "1px solid #6366F1 !important",
                                                    color: "#6366F1 !important",
                                                    fontWeight: 500,
                                                    borderRadius: "10px !important",
                                                    height: "44px !important",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    textAlign: "center",
                                                    padding: "0px 16px 0px !important",
                                                }
                                            }}
                                        >
                                            <MenuItem value="" disabled>
                                                {t("generateDescTitle.templates")}
                                            </MenuItem>
                                            {listTemplate && listTemplate.map((template: any, index: any) => (
                                                <MenuItem key={index} value={template}>{template.name}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>

                            <div className="row card-form mb-4">

                                <DescriptionDetails property={property} errors={errors} onChangeDesc={handleChangeDescTitle} />

                                <div className="d-flex mt-1 align-items-center mb-4">
                                    <div className="form-check col-12 col-md-auto mb-2 marg-right-16">
                                        <input className="form-check-input" type="checkbox" onChange={handleChangeCheck} name="agencyIntroduction" checked={property.descriptionTitle?.agencyIntroduction ? property.descriptionTitle.agencyIntroduction : ""} />
                                        <label className="form-check-label" htmlFor="defaultCheck2" style={{ cursor: "pointer" }}>
                                            {t("generateDescTitle.addAgencyIntro")}
                                        </label>
                                    </div>
                                    <div className="col-12 col-md-auto mb-2 marg-right-16">
                                        <FormControl className="width-180">
                                            <Select
                                                labelId="demo-multiple-checkbox-label"
                                                multiple
                                                className={`input-property ${errors.lang ? 'input-error' : ''}`}
                                                value={property.lang ?? []}
                                                onChange={handleSelectLanguge}
                                                renderValue={(selected) => selected.map((s) => s.charAt(0).toUpperCase() + s.slice(1)).join(', ')}
                                            >
                                                {getLanguageOptions(property?.address?.country).map((lang: any) => (
                                                    <MenuItem key={lang.value} value={lang.value}>
                                                        <Checkbox checked={property.lang?.includes(lang.value) ?? false} />
                                                        <ListItemText primary={lang.label} />
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className=" mb-2 marg-left-auto">
                                        <button className="button-reset back-E0E7FF color-746AFF border-trans padd-15 width-max-content" onClick={() => { setIsOpen(true); setTemplateName("") }}>
                                            {t("generateDescTitle.saveParameters")}
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="d-flex justify-content-center mb-4">
                                <button type="submit" className={`button-dash back-746AFF color-FFFFFF  border-746AFF padd-15-30 `} onClick={Generate}>
                                    {t("generateDescTitle.generate")} {isGenerate && <div className="spinner-border text-white" style={{ width: "20px", height: "20px" }} role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>}
                                </button>
                            </div>

                            <h3 className="title-20 title-18-mb color-black mb-4 mt-4">
                                {t("generateDescTitle.description")}
                            </h3>

                            <GenerateDescription descValue={getDescriptionByLang(langDesc)} languages={property.lang} langDesc={langDesc} onCopyText={handleCopyText} onEditDesc={handleEditDesc} onGenerateDesc={handleGenerateDesc} onChangeLang={ChangeLangDesc} />

                            <h3 className="title-20 title-18-mb color-black mb-4">
                                {t("generateDescTitle.title")}
                            </h3>

                            <GenerateTitle titleValue={getTitleByLang(langTitle)} languages={property.lang} langTitle={langTitle} onCopyText={handleCopyText} onEditTitle={handleEditTitle} onGenerateTitle={handleGenerateTitle} onChangeLang={ChangeLangTitle} />

                            <div className="d-flex justify-content-end mb-4 mt-4">
                                <button type="submit" onClick={handleSaveDesc} className={`button-dash back-EEF2FF border-6366F1 color-475569  padd-15-30 width-auto marg-right-16 ${isFormValid() ? "" : "disabled"}`} >
                                    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clipPath="url(#clip0_851_2515)">
                                            <path d="M14 5.25V15.75L9.5 12.75L5 15.75V5.25C5 4.45435 5.31607 3.69129 5.87868 3.12868C6.44129 2.56607 7.20435 2.25 8 2.25H11C11.7956 2.25 12.5587 2.56607 13.1213 3.12868C13.6839 3.69129 14 4.45435 14 5.25Z" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_851_2515">
                                                <rect width="18" height="18" fill="white" transform="translate(0.5)" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    {t("propertiesPage.save")}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Snackbar open={openSnackbar} onClose={handleCloseSnackbar} autoHideDuration={50000}>
                <Alert
                    onClose={handleCloseSnackbar}
                    severity={colorSnackbar || "info"}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {message}
                </Alert>
            </Snackbar>

            <Dialog
                open={isOpen}
                onClose={() => setIsOpen(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="xs"
                fullWidth={true}
            >
                <DialogTitle >
                    <div className="para-16 bold-600 ">{t("generateDescTitle.template")}</div>
                </DialogTitle>

                <IconButton
                    aria-label="close"
                    onClick={() => setIsOpen(false)}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon />
                </IconButton>

                <DialogContent>
                    <label className="form-label font-16 mb-3" htmlFor="selectTypeOpt">{t("generateDescTitle.templateName")}</label>
                    <input type="text" className="form-input border-E6E6E6" placeholder={t("generateDescTitle.enterTemplateName")} value={templateName || ''} onChange={handleChangeTemplate} />
                    <div className="mt-4 d-flex justify-content-center">
                        <button type="button" onClick={SaveTemplate} className={`button-dash back-746AFF color-FFFFFF  padd-10-30 border-746AFF marg-right-16 ${templateName ? "" : "disabled"}`} data-bs-dismiss="modal">{t("propertiesPage.save")}</button>
                    </div>
                </DialogContent>

            </Dialog>


        </div>
    )
}

export default GenerateNewDescription;